module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.23482",
      "conversations-internal-schema": "static-1.11474",
      "head-dlb": "static-1.4003",
      "hs-test-utils": "static-1.6821",
      "hubspot-url-utils": "static-1.3177",
      "HubStyleTokens": "static-2.10320",
      "I18n": "static-7.1391",
      "jasmine-runner": "static-1.5227",
      "quartz": "static-1.5576",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.461",
      "visitor-ui-component-library": "static-1.5012",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4306",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4766",
      "raven-hubspot": "static-1.5073",
      "bend-plugin-trellis-migration": "static-1.2467",
      "moment": "static-3.26",
      "hub-http": "static-1.4807",
      "immutable": "static-2.19",
      "quartz-core": "static-1.4795",
      "transmute": "static-2.29",
      "HeadJS": "static-2.577",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6022",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.1932",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.121",
      "foundations-theming": "static-1.3142",
      "i18n-data": "static-1.197",
      "metrics-js": "static-1.8596",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4338",
      "jasmine": "static-4.3162",
      "quartz-core-utils": "static-1.2443",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "react-aria": "static-1.39",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7268",
      "visitor-ui-component-library-icons": "static-1.4823",
      "copilot-toolkit": "static-1.6525",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.648",
      "hub-http-shared-msw-handlers": "static-1.7089",
      "hubspotter-http": "static-1.3599",
      "hubspotter-http-shared-msw-handlers": "static-1.7087",
      "icons": "static-2.592",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11233",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15402",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-components": "static-1.2290",
      "floating-ui": "static-1.29",
      "foundations-assets": "static-1.3748",
      "foundations-theming-specialty": "static-1.859",
      "hs-story-utils": "static-1.8213",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.839",
      "bend-plugin-foundations-theming": "static-1.1625",
      "foundations-theming-base": "static-1.2127",
      "classnames": "static-2.10",
      "cssUtils": "static-1.499",
      "HubStyle": "static-2.10629",
      "chatspot-client-types": "static-1.8620",
      "chatspot-core": "static-1.15762",
      "ts-schema": "static-1.3149",
      "sassPrefix": "static-1.131",
      "platform-infra-nav-components": "static-1.6706",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.23482",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11474",
      "head-dlb": "/head-dlb/static-1.4003",
      "hs-test-utils": "/hs-test-utils/static-1.6821",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3177",
      "HubStyleTokens": "/HubStyleTokens/static-2.10320",
      "I18n": "/I18n/static-7.1391",
      "jasmine-runner": "/jasmine-runner/static-1.5227",
      "quartz": "/quartz/static-1.5576",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5012",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4766",
      "raven-hubspot": "/raven-hubspot/static-1.5073",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2467",
      "moment": "/moment/static-3.26",
      "hub-http": "/hub-http/static-1.4807",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.4795",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.577",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6022",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1932",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.121",
      "foundations-theming": "/foundations-theming/static-1.3142",
      "i18n-data": "/i18n-data/static-1.197",
      "metrics-js": "/metrics-js/static-1.8596",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4338",
      "jasmine": "/jasmine/static-4.3162",
      "quartz-core-utils": "/quartz-core-utils/static-1.2443",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "react-aria": "/react-aria/static-1.39",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7268",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4823",
      "copilot-toolkit": "/copilot-toolkit/static-1.6525",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7089",
      "hubspotter-http": "/hubspotter-http/static-1.3599",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7087",
      "icons": "/icons/static-2.592",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11233",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15402",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2290",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-assets": "/foundations-assets/static-1.3748",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.859",
      "hs-story-utils": "/hs-story-utils/static-1.8213",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.839",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1625",
      "foundations-theming-base": "/foundations-theming-base/static-1.2127",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.499",
      "HubStyle": "/HubStyle/static-2.10629",
      "chatspot-client-types": "/chatspot-client-types/static-1.8620",
      "chatspot-core": "/chatspot-core/static-1.15762",
      "ts-schema": "/ts-schema/static-1.3149",
      "sassPrefix": "/sassPrefix/static-1.131",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6706",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};